import React from "react";
import { useState, useEffect } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../Lib/Init-firebase";
import Sidebarlayout from "../../Layouts/Sidebarlayout";
import "../../Assets/Css/Messages.scss";
import Table from "../../Components/Table";

const Messages = () => {
  const [message, setMessage] = useState([]);

  useEffect(() => {
    const messageCollectionRef = collection(db, "users");
    const unViewMessage = onSnapshot(messageCollectionRef, (snapshot) => {
      setMessage(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }))
      );
    });
    return () => {
      unViewMessage();
    };
  }, []);


  const header = [
    { field: 'Name' },
    { field: 'Email' },
    { field: 'Phone Number' },
    { field: 'Subject' }
  ]

  let footer = true;

  const data = message.map((msg) => {
    return (
      {
        Name: {
          value: msg.data.name,
          type: 'text',
        },
        Email: {
          value: msg.data.email,
          type: 'text',
        },
        'Phone Number': {
          value: msg.data.phoneNumber,
          type: 'text',
        },
        Subject: {
          value: msg.data.subject,
          type: 'text',
        },
        description: {
          value: msg.data.description,
          type: 'text',
        },
        id: {
          value: msg.id,
          type: 'text',
        }
      }
    )
  });

  return (
    <Sidebarlayout>
      <div className="main-message">
        <div className="page-title">
          <h4 >Messages</h4>
        </div>
        <div className="content-part">
          <Table header={header} data={data} footer={footer} />
        </div>
      </div>
    </Sidebarlayout>
  );
};

export default Messages;
